/**
 * Die Quellenangabe des Abbinders — eine Auflösung für Leser und Vorschau.
 *
 * DREI EINGETIPPTE QUELLEN, EINE ANGEZEIGT (Jans Fund 05.08.2026): Er schrieb
 * drei `[Titel](url)`-Einträge UNTEREINANDER. Der alte Leser zerlegte den Text
 * aber ausschliesslich am Trennzeichen „ • " und suchte je Stück nur den ERSTEN
 * Link — bei Zeilenumbrüchen war alles ein einziges Stück, und aus drei Quellen
 * wurde eine.
 *
 * Jetzt werden ALLE Links im Text gefunden, egal wie sie getrennt sind: Zeile
 * für Zeile, mit Aufzählungspunkt, mit Komma, hintereinander weg. Das Feld ist
 * ein freies Textfeld — dann darf die Trennung auch frei sein.
 */

export interface QuellenEintrag {
    label: string;
    url: string;
}

export interface AufgeloesteQuellen {
    /** Gefundene `[Titel](url)`-Einträge, ohne Rechtslinks (s. unten). */
    links: QuellenEintrag[];
    /**
     * Quellenangabe als freier Text — nur, wenn ÜBERHAUPT keine Links
     * drinstehen. Sonst stünden die unten herausgefilterten Rechtslinks über
     * den Rohtext wieder da.
     */
    text: string;
}

/** Findet JEDEN `[Titel](url)`-Eintrag, unabhängig vom Trennzeichen. */
const LINK_MUSTER = /\[([^\]]*)\]\(([^)\s]+)\)/g;

/**
 * Impressum, Datenschutz und Barrierefreiheit gehören in die Fusszeile, nicht
 * in die Quellen. Templates haben sie früher mit Platzhalter-Adressen in die
 * Quellen geschrieben, wo sie doppelt und falsch erschienen (Befund
 * WESER-KURIER). Sie werden beim Anzeigen entfernt — ohne die gespeicherten
 * Daten anzufassen; echte Quellen laufen unverändert durch.
 */
const RECHTSLINKS: RegExp[] = [
    /impressum|imprint/i,
    /datenschutz|privacy/i,
    /barrierefrei|accessibility/i,
];

export function resolveColophonSources(
    sourcesMd: string | null | undefined,
): AufgeloesteQuellen {
    if (!sourcesMd || typeof sourcesMd !== "string") return { links: [], text: "" };

    const alle: QuellenEintrag[] = [];
    for (const treffer of sourcesMd.matchAll(LINK_MUSTER)) {
        const label = (treffer[1] ?? "").trim();
        const url = (treffer[2] ?? "").trim();
        if (!label || !url) continue;
        alle.push({ label, url });
    }

    if (alle.length === 0) {
        return { links: [], text: sourcesMd.trim() };
    }
    return {
        links: alle.filter((q) => !RECHTSLINKS.some((re) => re.test(q.label))),
        text: "",
    };
}
